// src/utils/toast.js

export function showToast({ message, type = 'info', duration = 3500, id, slideFrom, slow, align, pill, variant, delayMs } = {}) {
  try {
    window.dispatchEvent(new CustomEvent('toast:show', {
      detail: { message, type, duration, id, slideFrom, slow, align, pill, variant, delayMs }
    }));
  } catch (e) {
    // noop
  }
}

export function clearToasts() {
  try {
    window.dispatchEvent(new CustomEvent('toast:clear'));
  } catch (e) {
    // noop
  }
}

export function hideToast(id) {
  try {
    window.dispatchEvent(new CustomEvent('toast:hide', { detail: { id } }));
  } catch (e) {}
}

export function updateToast({ id, message, type, align, pill, variant }) {
  try {
    window.dispatchEvent(new CustomEvent('toast:update', {
      detail: { id, message, type, align, pill, variant }
    }));
  } catch (e) {}
}

export function greetUserToast(user) {
  const raw = user?.fullname || user?.name || user?.login || 'there';
  const firstName = String(raw).trim().split(/\s+/)[0] || 'there';
  // Match "welcome" copy style we used before
  showToast({
    message: `Welcome back, ${firstName}! 👋`,
    type: 'info',
    duration: 5000,
    slideFrom: 'top',
    slow: true,
    align: 'center',
    pill: true,
    variant: 'welcome',
    delayMs: 250,
  });
}
